import { render } from "./BCPView.vue?vue&type=template&id=9985a99e&scoped=true"
import script from "./BCPView.vue?vue&type=script&lang=js"
export * from "./BCPView.vue?vue&type=script&lang=js"

import "./BCPView.vue?vue&type=style&index=0&id=9985a99e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9985a99e"]])

export default __exports__